var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.703 12.222c-.155-.156-.233-.234-.324-.29a.9.9 0 0 0-.26-.107c-.104-.025-.214-.025-.434-.025H4c-.274 0-.51 0-.722.033a2.7 2.7 0 0 0-2.245 2.245C1 14.29 1 14.525 1 14.8v.134c0 .43 0 .748.044 1.03a3.6 3.6 0 0 0 2.993 2.992c.281.044.6.044 1.029.044h9.868c.43 0 .748 0 1.03-.044a3.6 3.6 0 0 0 2.992-2.993c.044-.281.044-.6.044-1.029V14.8c0-.275 0-.51-.033-.722a2.7 2.7 0 0 0-2.245-2.245c-.212-.033-.448-.033-.722-.033h-.685c-.22 0-.33 0-.434.025a.9.9 0 0 0-.26.108c-.09.055-.169.133-.324.289l-2.388 2.387a2.7 2.7 0 0 1-3.818 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.9 1.9a.9.9 0 1 0-1.8 0v8.627L6.136 7.564a.9.9 0 1 0-1.272 1.272l4.5 4.5a.9.9 0 0 0 1.272 0l4.5-4.5a.9.9 0 0 0-1.272-1.272L10.9 10.527z"
  })));
};
export default SvgDownload;